// Dourado vocabulary expansion — DESCRIBING theme (net-new cards).
//
// Extends the `describing` blocks in ./vocabulary.js without reusing any headword
// already defined there. Seed upserts on `portuguese`, so every value is unique.
//   [ portuguese, english, emoji, part_of_speech, gender, example_pt, example_en ]

export const VOCAB_DESCRIBING = [
  {
    theme: "describing", tier: "A1", rows: [
      ["alto", "tall", "📏", "adjective", "", "O meu irmão é muito alto.", "My brother is very tall."],
      ["baixo", "short (height)", "📐", "adjective", "", "A mesa é demasiado baixa.", "The table is too low."],
      ["gordo", "fat", "🐷", "adjective", "", "O gato está um pouco gordo.", "The cat is a bit fat."],
      ["magro", "thin / slim", "🌿", "adjective", "", "É alta e magra.", "She's tall and slim."],
      ["jovem", "young", "🧒", "adjective", "", "O professor é muito jovem.", "The teacher is very young."],
      ["giro", "good-looking", "😎", "adjective", "", "A tua irmã é muito gira.", "Your sister is very good-looking."],
      ["redondo", "round", "⚪", "adjective", "", "A mesa é redonda.", "The table is round."],
      ["quadrado", "square", "🟦", "adjective", "", "A caixa é quadrada.", "The box is square."],
      ["cheio", "full", "🪣", "adjective", "", "O copo está cheio.", "The glass is full."],
      ["vazio", "empty", "🫙", "adjective", "", "A garrafa está vazia.", "The bottle is empty."],
    ],
  },
  {
    theme: "describing", tier: "A2", rows: [
      ["amplo", "spacious / roomy", "🏠", "adjective", "", "A sala é muito ampla.", "The living room is very spacious."],
      ["barulhento", "noisy", "🔊", "adjective", "", "O bar é demasiado barulhento.", "The bar is too noisy."],
      ["silencioso", "quiet / silent", "🤫", "adjective", "", "O motor é muito silencioso.", "The engine is very quiet."],
      ["confortável", "comfortable", "🛋️", "adjective", "", "O sofá é muito confortável.", "The sofa is very comfortable."],
      ["desconfortável", "uncomfortable", "🪑", "adjective", "", "A cadeira é desconfortável.", "The chair is uncomfortable."],
      ["útil", "useful", "🛠️", "adjective", "", "Esta aplicação é muito útil.", "This app is very useful."],
      ["inútil", "useless", "🚯", "adjective", "", "O comando velho é inútil.", "The old remote is useless."],
      ["moderno", "modern", "🏢", "adjective", "", "O edifício é muito moderno.", "The building is very modern."],
      ["antigo", "old / antique", "🏛️", "adjective", "", "Têm um relógio antigo.", "They have an antique clock."],
      ["duro", "hard / tough", "🪵", "adjective", "", "O pão está duro.", "The bread is hard."],
    ],
  },
  {
    theme: "describing", tier: "B1", rows: [
      ["minucioso", "meticulous / thorough", "🔍", "adjective", "", "Fez uma análise minuciosa.", "He did a thorough analysis."],
      ["frágil", "flimsy / frail", "🍂", "adjective", "", "A estrutura é frágil.", "The structure is flimsy."],
      ["resistente", "tough / durable", "🛡️", "adjective", "", "O tecido é muito resistente.", "The fabric is very durable."],
      ["volumoso", "bulky", "📦", "adjective", "", "A encomenda é volumosa.", "The package is bulky."],
      ["minúsculo", "tiny", "🐜", "adjective", "", "Encontrou um erro minúsculo.", "She found a tiny error."],
      ["vistoso", "eye-catching / showy", "🎨", "adjective", "", "Usa um vestido muito vistoso.", "She's wearing a very eye-catching dress."],
      ["trabalhoso", "cumbersome / awkward", "🧶", "adjective", "", "O processo é trabalhoso.", "The procedure is cumbersome."],
      ["versátil", "versatile", "🔧", "adjective", "", "É uma ferramenta versátil.", "It's a versatile tool."],
      ["conciso", "concise / terse", "✂️", "adjective", "", "Enviou uma mensagem concisa.", "He sent a terse message."],
      ["nítido", "crisp / sharp (clear)", "🔭", "adjective", "", "A imagem vê-se nítida.", "The image looks crisp."],
    ],
  },
];
